<template>
  <div class="d-flex justify-center align-center">
    <v-card min-width="400">
      <v-container fluid>
        <v-row>
          <v-col v-if="settings && logoLoaded" class="col-12 col-sm-6">
            <v-img height="100%" contain src="" alt="Napco Truck Tracking" class="logo" />
          </v-col>
          <v-col class="left-border col-12" :class="logoLoaded ? 'col-sm-6' : ''">
          <img src="../assets/napco-logo.png" style="width: 142px;
    margin-left: 30%;"/>
            <v-card-title>Napco Truck Tracking</v-card-title>
            <v-card-subtitle>Sign in to access the CMS</v-card-subtitle>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-form ref="loginForm">
                    <v-alert color="primary lighten-1" type="error" v-if="message != ''" dense>{{message}}</v-alert>
                    <v-text-field
                      color="green"
                      outlined
                      dense
                      label="Email"
                      v-model="user.email"
                      :disabled="loading"
                    ></v-text-field>
                    <v-text-field
                      color="green"
                      outlined
                      dense
                      label="Password"
                      type="password"
                      v-model="user.password"
                      :disabled="loading"
                      @keypress.enter="submit"
                    ></v-text-field>
                    <v-btn color="primary" @click="submit" :loading="loading" :disabled="user.email == '' || user.password == ''">
                      <v-icon left dark>mdi-login</v-icon>Sign In
                    </v-btn>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      message: "",
      loading: false,
      user: {
        email: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapState({
      settings: state => state.settings.settings
    }),
    logoLoaded() {
      console.log(this.settings)
      if(this.settings !== undefined)
        return ""
      return false
    }
  },
  methods: {
    ...mapActions('users',['authenticate']),
    submit() {
      this.message = "";
      this.loading = true;
      if (this.$refs.loginForm.validate()) {
        this.authenticate(this.user)
          .then(message => { 
this.$router.push('home') 

          })
          .catch(message => {
            this.message = message; 
          })
          .finally(_ => {
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;
  max-width: 400px;
}

.left-border {
  border-left: 1px solid rgba(black,0.1);
}
</style>